// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__A2KpE","lander":"Home_lander__ckxja"};